import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import type { SessionEventApi } from '#common/zod/backend/session-event-api';
import { BaseQuery } from './base.query';

export class SessionEventsState {
  liveEvents: SessionEventApi[];
}

let sessionEventsState: SessionEventsState = {
  liveEvents: []
};

@Injectable({ providedIn: 'root' })
export class SessionEventsQuery extends BaseQuery<SessionEventsState> {
  liveEvents$ = this.store.pipe(select(state => state.liveEvents));

  constructor() {
    super(
      createStore(
        { name: 'sessionEvents' },
        withProps<SessionEventsState>(sessionEventsState)
      )
    );
  }
}
